import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Toy yellow is the action color on this page.
 * Coral is reserved for tension (pain marks, price rise, the "without" column).
 * Sized for thumbs first: full width, 56px+ tall, single-line labels.
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-4 text-[17px] sm:px-7 sm:py-5 sm:text-xl rounded-full min-h-[58px] sm:min-h-[64px]' : 'px-5 py-3 text-[15px] rounded-full min-h-[48px]';
  return <a href={href} className={`inline-flex w-full items-center justify-center whitespace-nowrap text-center gap-2 bg-gold hover:bg-gold-hover active:scale-[0.98] text-gold-ink font-bold shadow-card hover:shadow-lift border-b-4 border-gold-deep/40 transition-[background-color,box-shadow,transform] duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-smoke/50 ${sizing} ${className}`} data-id="element-86" data-mp="109llkgb8vmbz">
      {children}
    </a>;
}